module.exports = __webpack_public_path__ + "static/media/Offerio.b940182f.svg";